import React from 'react';
import { useQueryId, useSeriesId } from '@/hooks';
import { useAppDispatch } from '@/store/hooks';
import { RESET_STEPS_STATE } from '@/actions/constants';

export const useResetSteps = () => {
  const dispatch = useAppDispatch();
  const queryId = useQueryId();
  const seriesId = useSeriesId();

  const isOnQueryBuilderPage = !!(queryId || seriesId);

  React.useEffect(() => {
    if (!isOnQueryBuilderPage) {
      dispatch({ type: RESET_STEPS_STATE });
    }
  }, [isOnQueryBuilderPage]);
};
